import ApiService from "@/services/Api"

import { WABATemplateCategory } from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"

export type WABATemplateCreditCosts = Partial<Record<WABATemplateCategory, number>>

export type WABATemplateCreditsInfo = {
	totalCredits: number
	usedCredits: number
	availableCredits: number
}

type GetWABATemplateCreditsInfoResponse = {
	creditsInfo: WABATemplateCreditsInfo
}

class WABATemplateCreditsService {
	async getCreditsInfo (): Promise<WABATemplateCreditsInfo> {
		const response = await ApiService.get<GetWABATemplateCreditsInfoResponse>("/waba/template/credits-usage")

		return response.data.creditsInfo
	}
}

export default new WABATemplateCreditsService()
